import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-10 mx-auto" }
const _hoisted_2 = { class: "font-bold text-xl" }

import DataTable from "@/components/ui_custom/data-table/DataTable.vue";
import {onMounted, ref, watch} from "vue";
import {columns} from "./columns"
import TablesService from "@/services/tables/tables.service";
import useEventsBus from "@/utils/eventBus";
import {i18n} from "@/utils/i18n";
import {toast} from "@/utils/utils";
import {ServiceOrder} from "@/models/tables/serviceOrder.interface";
import ServiceOrdersEditForm from "@/components/tables/service_orders/ServiceOrdersEditForm.vue";

const entity = 'service-order';

export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceOrdersTable',
  setup(__props) {

const data = ref<ServiceOrder[]>([]);
const { bus } = useEventsBus();
const isAddDialogOpen = ref(false);
const object = {};

async function getData(): Promise<ServiceOrder[]> {
  const res = await TablesService.getData(entity);
  return res?.data;
}

const setIsAddDialogOpen = (value: boolean) => {
  isAddDialogOpen.value = value;
};

onMounted(async () => {
  data.value = await getData();
})

watch(() => bus.value.get('new_'+entity), async () => {
  setIsAddDialogOpen(true);
})

watch(() => bus.value.get('delete_'+entity), async (value) => {
  await TablesService.deleteRecord(value, entity);
  data.value = data.value.filter(row => row.id !== value);
  toast.success(i18n.global.t('toast.delete_success'));
})

watch(() => bus.value.get('update_'+entity), async (value) => {
  const object = data.value.some(obj => obj.id === value.id)
  if (!object) {
    data.value = [...data.value, value];
  } else {
    data.value = await getData();
  }
  setIsAddDialogOpen(false);
  toast.success(i18n.global.t('toast.edit_success'));
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('table.service_orders_list')), 1),
      _createVNode(DataTable, {
        columns: _unref(columns),
        data: data.value,
        entity: entity
      }, null, 8, ["columns", "data"])
    ]),
    _createVNode(ServiceOrdersEditForm, {
      entity: entity,
      object: object,
      open: isAddDialogOpen.value,
      "set-open": setIsAddDialogOpen
    }, null, 8, ["open"])
  ], 64))
}
}

})